import { Col, Row } from "antd";
import {DollarCircleFilled,PhoneFilled,ToolFilled } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getLabList, getMachineList, insertMachineInstallRequestList } from "../../api/api";
import FormContainer from "../../components/FormContainer/FormContainer";
import CustomSelect from "../../components/_common/CustomSelect";
import CustomTextArea from "../../components/_common/CustomTextArea";
import Input from "../../components/_common/Input";
import { UpdateLabList } from "../../redux/reducers/lablistSlice";
import { UpdateMachineList } from "../../redux/reducers/machinelistSlice";
import { useAppDispatch, useAppSelector } from "../../redux/store/storehooks";
import { errorNotify, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import { MachineInstallRequestForm } from "../../utility/validationRules";
import {InfoContainer, InfoText, InfoTextRed, StyledContainer } from "./styles";

const NewMachineInstallRequest = () => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(MachineInstallRequestForm) as any
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [choosenMachine,setChoosenMachine] = useState({str_MachineName:"",int_InstallationType:0,str_InstallationType:""});
    const myStore = useAppSelector((state) => state)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(()=>{

        if (myStore.labList.list && myStore.machineList.list) setIsLoading(false);
        if (!myStore.labList.list) loadLabs(); 
        if (!myStore.machineList.list) loadMachines();

        if (myStore.auth.loginType === "labuser" ) {
            setValues((values:any) => ({
                ...values,
                ["lab"]: myStore.auth.userId,
              }));
        }


    },[])


    const loadLabs = () => {

        getLabList()
        .then((result:any) => {
            console.log(result.data.data);
            dispatch(UpdateLabList({labList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const loadMachines = () => {

        getMachineList()
        .then((result:any) => {
            dispatch(UpdateMachineList({machineList:result.data.data}))
            setIsLoading(false);
        })
        .catch((error) => {
          console.log(error);
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    const FormSubmit = (e:any) => {
        e.preventDefault();
        
        let error= MachineInstallRequestForm(values);
        if (Object.keys(error).length == 0)
        {

            setIsSubmiting(true)

            insertMachineInstallRequestList(Number(values.machine),Number(values.lab),values.mobile,values.description ? values.description : "")
            .then((result:any) => {
                console.log(result);
                setIsSubmiting(false)
                navigate("/" + myStore.auth.loginType + "/machineInstallRequest");
                sucessNotify("ثبت با موفقیت انجام شد")
            })
            .catch((error) => {
                setIsSubmiting(false)
                errorNotify(error.response.data.errorMessage,undefined,5000)
            })

        }
        else
        {
          setErrors(error);
        }
        
    }

    const machineHandleChanges = (event:any) => {
        handleChange(event);

        console.log(event)
        console.log(event.target.value);

        let selectedMachine = myStore.machineList.list.find((machine: any) => machine.prk_MachineInfo_AutoID == event.target.value);
        setChoosenMachine(selectedMachine);
    }

    return(
        <StyledContainer>

           <FormContainer title="درخواست نصب دستگاه جدید" onSubmit={FormSubmit} isLoading={isLoading} isSubmiting={isSubmiting}  > 
                    <Row>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <CustomSelect
                                name="machine"
                                placeholder="دستگاه"
                                itemList={myStore.machineList.list}
                                value={values.machine || ""}
                                onChange={machineHandleChanges}
                                valueObjectField={"prk_MachineInfo_AutoID"}
                                displayObjectField={"str_MachineName"}

                            />
                            <ValidationType type="machine" />
                        </Col>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <CustomSelect
                                name="lab"
                                placeholder="آزمایشگاه"
                                itemList={myStore.labList.list}
                                value={values.lab || ""}
                                onChange={handleChange}
                                valueObjectField={"prk_AndriodLab_AutoID"}
                                displayObjectField={"str_LabPersianName"}
                                disabled = {myStore.auth.loginType === "labuser" ? true : false}
                            />
                            <ValidationType type="lab" />
                        </Col>

                        <Col lg={8} md={8} sm={12} xs={24}>
                            <Input
                                type="text"
                                name="mobile"
                                placeholder="موبایل"
                                value={values.mobile || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="mobile" />
                        </Col>

                    </Row>
                    
                    <Row>
                        <Col lg={24} md={24} sm={24} xs={24}>
                            <CustomTextArea
                                name="description"
                                placeholder="توضیحات (شامل طول کابل / تلفن شرکت پشتیبان دستگاه و ...)"
                                value={values.description || ""}
                                onChange={handleChange}
                            />
                            <ValidationType type="description" />
                        </Col>
                    </Row>
                    <InfoContainer>
                        
                        <Row>
                                <Col>
                                    <DollarCircleFilled style={{ color: 'blue',fontSize: '24px' }} />
                                </Col>

                                <Col lg={23} md={23} sm={23} xs={23}>
                                    <InfoText>هزینه نصب دستگاه <InfoTextRed>{choosenMachine.str_MachineName}</InfoTextRed> به صورت <InfoTextRed>{choosenMachine.str_InstallationType}</InfoTextRed> عدد <InfoTextRed>{(choosenMachine.str_MachineName === "") ? "" : ((choosenMachine.int_InstallationType === 1) ? "170,000,000" : "280,000,000") }</InfoTextRed>ریال می باشد</InfoText>
                                </Col>
                        </Row>

                        {myStore.auth.loginType === 'labuser' && (
                            <>
                                <Row>
                                        <Col>
                                            <ToolFilled  style={{ color: myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true ? 'blue' : 'orange',fontSize: '24px' }} />
                                        </Col>

                                        {myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === true && (
                                            <Col lg={23} md={23} sm={23} xs={23}>
                                                <InfoText>بعد از ثبت درخواست و پرداخت آنلاین ، همکاران واحد پشتیبانی با شما تماس خواهد گرفت</InfoText>
                                            </Col>
                                        )}
                                        {myStore.auth.loginType === 'labuser' && myStore.auth.taxInfo.Bit_IsTax === false && (
                                            <Col lg={23} md={23} sm={23} xs={23}>
                                                <InfoText>آزمایشگاه مالیانی نمی باشد به همین دلیل امکان پرداخت آنلاین نمی باشد. برای پرداخت با قسمت مالی شرکت هماهنگ نمایید</InfoText>
                                            </Col>
                                        )}
                                </Row>
                                <Row>
                                        <Col>
                                            <PhoneFilled  style={{ color: 'blue',fontSize: '24px' }} />
                                        </Col>
                                        <Col lg={23} md={23} sm={23} xs={23}>
                                            <InfoText>در صورتی که دستگاه مورد نظر شما در لیست دستگاه های شرکت وجود نداشت لطفا با شرکت تماس بفرمایید</InfoText>
                                        </Col>
                                </Row>
                            </>
                        )}

                    </InfoContainer>

           </FormContainer>

        </StyledContainer>
    )
}

export default NewMachineInstallRequest;